(function () {
    define('commons/chartServices',["jquery"],
        function ($) {

            var CanvasRenderer = function (element, options) {
                var cachedBackground;
                var canvas = document.createElement("canvas");

                element.appendChild(canvas);

                var ctx = canvas.getContext("2d");

                canvas.width = canvas.height = options.size;

                // move 0,0 coordinates to the center
                ctx.translate(options.size / 2, options.size / 2);

                // rotate canvas -90deg
                ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI);

                var radius = (options.size - options.lineWidth) / 2;

                Date.now = Date.now ||
                    function () {

                        //convert to milliseconds
                        return +(new Date());
                    };

                var drawCircle = function (color, lineWidth, percent) {
                    percent = Math.min(Math.max(-1, percent || 0), 1);
                    var isNegative = percent <= 0 ? true : false;

                    ctx.beginPath();
                    ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, isNegative);

                    ctx.strokeStyle = color;
                    ctx.lineWidth = lineWidth;

                    ctx.stroke();
                };

                /**
                 * Return function request animation frame method or timeout fallback
                 */
                var reqAnimationFrame = (function () {
                    return window.requestAnimationFrame ||
                        window.webkitRequestAnimationFrame ||
                        window.mozRequestAnimationFrame ||
                        function (callback) {
                            window.setTimeout(callback, 1000 / 60);
                        };
                }());

                /**
                 * Draw the background of the plugin track
                 */
                var drawBackground = function () {
                    if (options.trackColor) drawCircle(options.trackColor, options.lineWidth, 1);
                };

                /**
                 * Clear the complete canvas
                 */
                this.clear = function () {
                    ctx.clearRect(options.size / -2, options.size / -2, options.size, options.size);
                };

                /**
                 * Draw the complete chart
                 * param percent Percent shown by the chart between -100 and 100
                 */
                this.draw = function (percent) {
                    if (!!options.trackColor) {
                        // getImageData and putImageData are supported
                        if (ctx.getImageData && ctx.putImageData) {
                            if (!cachedBackground) {
                                drawBackground();
                                cachedBackground = ctx.getImageData(0, 0, options.size, options.size);
                            } else {
                                ctx.putImageData(cachedBackground, 0, 0);
                            }
                        } else {
                            this.clear();
                            drawBackground();
                        }
                    } else {
                        this.clear();
                    }

                    ctx.lineCap = options.lineCap;

                    // draw bar
                    drawCircle(options.barColor, options.lineWidth, percent / 100);
                }.bind(this);

                this.animate = function (from, to) {
                    var startTime = Date.now();

                    var animation = function () {
                        var process = Math.min(Date.now() - startTime, options.animate.duration);

                        var currentValue = options.easing(this, process, from, to - from, options.animate.duration);

                        this.draw(currentValue);

                        //Show the number at the center of the circle
                        options.onStep(from, to, currentValue);

                        if (process < options.animate.duration) {
                            reqAnimationFrame(animation);
                        }
                    }.bind(this);

                    reqAnimationFrame(animation);
                }.bind(this);
            };

            var pieChart = function (element, userOptions) {
                var defaultOptions = {
                    barColor: "#ef1e25",
                    trackColor: "#f9f9f9",
                    lineCap: "round",
                    lineWidth: 3,
                    size: 150,
                    rotate: 0,
                    percent: 0,
                    animate: {
                        duration: 1000,
                        enabled: true
                    },
                    easing: function (x, t, b, c, d) { //copy from jQuery easing animate
                        t = t / (d / 2);
                        if (t < 1) {
                            return c / 2 * t * t + b;
                        }
                        return -c / 2 * ((--t) * (t - 2) - 1) + b;
                    },
                    onStep: function (from, to, currentValue) {
                        return;
                    },
                    renderer: CanvasRenderer //Maybe SVGRenderer more later
                };

                var options = {};
                var currentValue = 0;

                var init = function () {
                    this.element = element;
                    this.options = options;

                    // merge user options into default options
                    for (var i in defaultOptions) {
                        if (defaultOptions.hasOwnProperty(i)) {
                            options[i] = userOptions && typeof (userOptions[i]) !== "undefined"
                                ? userOptions[i]
                                : defaultOptions[i];
                            if (typeof (options[i]) === "function") {
                                options[i] = options[i].bind(this);
                            }
                        }
                    }

                    // check for jQuery easing, use jQuery easing first
                    if (typeof (options.easing) === "string" &&
                        typeof (jQuery) !== "undefined" &&
                        jQuery.isFunction(jQuery.easing[options.easing])) {
                        options.easing = jQuery.easing[options.easing];
                    } else {
                        options.easing = defaultOptions.easing;
                    }

                    // create renderer
                    this.renderer = new options.renderer(element, options);

                    // initial draw
                    this.renderer.draw(currentValue);

                    var newValue = parseFloat(options.percent);

                    if (options.animate.enabled) {
                        this.renderer.animate(currentValue, newValue);
                    } else {
                        this.renderer.draw(newValue);
                    }

                    currentValue = newValue;

                    /*
                    if (element.getAttribute && element.getAttribute('data-percent')) {
                        var newValue = parseFloat(element.getAttribute('data-percent'));

                        if (options.animate.enabled) {
                            this.renderer.animate(currentValue, newValue);
                        } else {
                            this.renderer.draw(newValue);
                        }

                        currentValue = newValue;
                    }
                    */
                }.bind(this)();
            };

            $.fn.pieChart = function (options) {

                //Iterate all the dom to draw the pie-charts
                return this.each(function () {
                    if (!$.data(this, "pieChart")) {
                        var userOptions = options;
                        //var userOptions = $.extend({}, options, $(this).data());
                        $.data(this, "pieChart", new pieChart(this, userOptions));
                    }
                });
            };

            // Highcharts should probably be required, but for now load it first in HTML

            function renderDrillChart(chartName, data, settings) {
                Highcharts.chart(chartName, {
                    chart: {
                        type: 'bar'

                    },
                    title: {
                        text: null
                    },

                    xAxis: {
                        type: 'category',
                        lineColor: 'transparent',
                        tickLength: 0
                    },
                    yAxis: {
                        title: {
                            text: null
                        },
                        min: 0,
                        gridLineColor: 'transparent',
                        lineWidth: 0,
                        labels: {
                            enabled: false,
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    legend: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            borderWidth: 0,
                            dataLabels: {
                                enabled: true,
                                format: '{point.y:.1f}%'
                            }
                        }
                    },

                    tooltip: {
                        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
                    },

                    series: data
                });
            }

            function renderColumnChart(chartName, data, settings) {
                var currentSettings = {
                    labelsFormat: settings.labelsFormat || "{point.y:,.0f}",
                    labelsUseRotation: settings.useLabelsRotation || false,
                    labelsRotation: 0,
                    labelsCrop: true,
                    labelsOverflow: "justify",
                    labelsY: 3,
                    labelsX: 0,
                    xAxisType: settings.xAxisType || "category",
                    xAxisTickAmount : settings.xAxisTickAmount,
                    yAxisType: settings.yAxisType || "category",
                    yAxisTickAmount: settings.yAxisTickAmount,
                    yAxisMaxPadding: settings.yAxisMaxPadding || 0.05,
                    yAxisMinPadding: settings.yAxisMinPadding || 0.05
                }

                if (currentSettings.labelsUseRotation === true) {
                    currentSettings.labelsRotation = 315;
                    currentSettings.labelsCrop = false;
                    currentSettings.labelsOverflow = "none";
                    currentSettings.labelsY = -16;
                    currentSettings.labelsX = 8;
                }

                var xAxis = settings.xAxis || {
                    type: currentSettings.xAxisType,
                    tickAmount: currentSettings.xAxisTickAmount,
                    //lineColor: currentSettings.xAxisLineColor,
                    minorTickLength: 0,
                    tickLength: 0,
                    labels: {
                        autoRotation: true,
                        style: { "color": "#848484", "cursor": "default", "fontSize": "12px", "fontFamily": "'GrotesqueMTStd', Arial, sans-serif, Tahoma" }
                    }
                }

                var yAxis = settings.yAxis || {
                    type: currentSettings.yAxisType,
                    title: false,
                    tickAmount: currentSettings.yAxisTickAmount,
                    labels: {
                        style: { "color": "#989898", "cursor": "default", "fontSize": "12px", "fontFamily": "'GrotesqueMTStd', Arial, sans-serif, Tahoma" }
                    },
                    maxPadding: currentSettings.yAxisMaxPadding,
                    minPadding: currentSettings.yAxisMinPadding,
                    //endOnTick: false
                }

                Highcharts.chart(chartName, {
                    chart: {
                        type: "column"
                    },
                    title: false,
                    credits: {
                        enabled: false
                    },
                    subtitle: false,
                    legend: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            borderWidth: 0,
                            dataLabels: {
                                enabled: true,
                                format: currentSettings.labelsFormat,
                                style: { "color": "#231f20", "cursor": "default", "fontSize": "12px", "fontWeight": "normal", "fontFamily": "'GrotesqueMTStd', Arial, sans-serif, Tahoma" },
                                rotation: currentSettings.labelsRotation,
                                crop: currentSettings.labelsCrop,
                                overflow: currentSettings.labelsOverflow,
                                y: currentSettings.labelsY,
                                x: currentSettings.labelsX
                            }
                        }
                    },
                    xAxis: xAxis,
                    yAxis: yAxis,
                    tooltip: false,
                    series: data
                });
            }

            function renderStackedColumnChart(chartName, data, settings) {
                var currentSettings = {
                    labelsFormat: settings.labelsFormat || "{point.y:,.0f}",
                    labelsUseRotation: settings.useLabelsRotation || false,
                    labelsRotation: 0,
                    labelsCrop: true,
                    labelsOverflow: "justify",
                    labelsY: 3,
                    labelsX: 0,
                    xAxisType: settings.xAxisType || "category",
                    xAxisTickAmount: settings.xAxisTickAmount,
                    yAxisType: settings.yAxisType || "category",
                    yAxisTickAmount: settings.yAxisTickAmount,
                    yAxisMaxPadding: settings.yAxisMaxPadding || 0.05,
                    yAxisMinPadding: settings.yAxisMinPadding || 0.05
                }

                if (currentSettings.labelsUseRotation === true) {
                    currentSettings.labelsRotation = 315;
                    currentSettings.labelsCrop = false;
                    currentSettings.labelsOverflow = "none";
                    currentSettings.labelsY = -16;
                    currentSettings.labelsX = 8;
                }

                var xAxis = settings.xAxis || {
                    type: currentSettings.xAxisType,
                    tickAmount: currentSettings.xAxisTickAmount,
                    minorTickLength: 0,
                    tickLength: 0,
                    labels: {                         
                        autoRotation: true,
                        style: { "color": "#848484", "cursor": "default", "fontSize": "12px", "fontFamily": "'GrotesqueMTStd', Arial, sans-serif, Tahoma" }
                    }                    
                }

                var yAxis = settings.yAxis || {
                    type: currentSettings.yAxisType,
                    title: false,
                    tickAmount: currentSettings.yAxisTickAmount,
                    labels: {
                        style: { "color": "#989898", "cursor": "default", "fontSize": "12px", "fontFamily": "'GrotesqueMTStd', Arial, sans-serif, Tahoma" }
                    },
                    maxPadding: currentSettings.yAxisMaxPadding,
                    minPadding: currentSettings.yAxisMinPadding,
                    stackLabels: {
                        labelsCrop: currentSettings.labelsCrop,
                        labelsOverflow: currentSettings.labelsOverflow,
                        x: currentSettings.labelsX,
                        y: currentSettings.labelsY,
                        rotation: currentSettings.labelsRotation,
                        enabled: true,
                        style: { "color": "#231f20", "cursor": "default", "fontSize": "12px", "fontWeight": "normal", "fontFamily": "'GrotesqueMTStd', Arial, sans-serif, Tahoma" }
                    }
                }

                Highcharts.setOptions({
                    lang: {
                        resetZoom: "Återställ"
                    }
                });

                Highcharts.chart(chartName, {
                    chart: {
                        type: "column",
                        events: {
                            load: function () {
                                this.series.forEach(function (s) {
                                    s.update({
                                        showInLegend: !s.points.every(function(x) { return x.isNull == true })
                                    });
                                });
                            }
                        },
                        zoomType: 'xy'
                    },                    
                    title: false,
                    credits: {
                        enabled: false
                    },
                    subtitle: false,
                    legend: {
                        enabled: true,
                        reversed: true
                    },
                    plotOptions: {
                        column: {
                            stacking: 'normal',
                            dataLabels: {
                                enabled: true,
                                color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
                            }
                        },
                        series: {
                            borderWidth: 0,
                            dataLabels: {
                                enabled: false,
                                format: currentSettings.labelsFormat,
                                style: { "color": "#231f20", "cursor": "default", "fontSize": "12px", "fontWeight": "normal", "fontFamily": "'GrotesqueMTStd', Arial, sans-serif, Tahoma" },
                                rotation: 0,
                                crop: currentSettings.labelsCrop,
                                overflow: currentSettings.labelsOverflow,
                                y: currentSettings.labelsY,
                                x: currentSettings.labelsX
                            }                         
                        }
                    },
                    xAxis: xAxis,
                    yAxis: yAxis,
                    tooltip: {
                        enabled: true
                    },
                    series: data
                });
            }

            function renderBarChart(chartName, data, settings) {
                var currentSettings = {
                    labelsFormat: settings.labelsFormat || "{point.y:,.0f}",
                    labelsUseRotation: settings.useLabelsRotation || false,
                    labelsRotation: 0,
                    labelsCrop: false,
                    labelsOverflow: "none",
                    labelsY: 0,
                    labelsX: 0,
                    xAxisType: settings.xAxisType || "category",
                    xAxisTickAmount: settings.xAxisTickAmount,
                    yAxisType: settings.yAxisType || "category",
                    yAxisTickAmount: settings.yAxisTickAmount,
                    yAxisMaxPadding: settings.yAxisMaxPadding || 0.05,
                    yAxisMinPadding: settings.yAxisMinPadding || 0.05
                }
                
                var xAxis = {
                    type: currentSettings.xAxisType,
                    labels: {
                        autoRotation: true,
                        style: { "color": "#231f20", "cursor": "default", "fontSize": "12px", "fontFamily": "'GrotesqueMTStd', Arial, sans-serif, Tahoma" }
                    }
                }

                var yAxis = {
                    //type: currentSettings.yAxisType,
                    title: false,
                    tickAmount: 6,
                    labels: {
                        style: {
                            "color": "#989898",
                            "cursor": "default",
                            "fontSize": "12px",
                            "fontFamily": "'GrotesqueMTStd', Arial, sans-serif, Tahoma",
                            "textOverflow": "none"
                        },
                        overflow: false
                    },
                    maxPadding: 0.17,
                    endOnTick: false
                }

                Highcharts.chart(chartName, {
                    chart: {
                        type: "bar"
                    },
                    title: false,
                    credits: {
                        enabled: false
                    },
                    subtitle: false,
                    legend: {
                        enabled: true
                    },
                    plotOptions: {
                        series: {
                            borderWidth: 0,
                            dataLabels: {
                                enabled: true,
                                format: currentSettings.labelsFormat,
                                style: { "color": "#231f20", "cursor": "default", "fontSize": "12px", "fontWeight": "normal", "fontFamily": "'GrotesqueMTStd', Arial, sans-serif, Tahoma" },
                                rotation: currentSettings.labelsRotation,
                                crop: currentSettings.labelsCrop,
                                overflow: currentSettings.labelsOverflow,
                                y: currentSettings.labelsY,
                                x: currentSettings.labelsX
                            }
                        }
                    },
                    xAxis: xAxis,
                    yAxis: yAxis,
                    tooltip: false,
                    series: data
                });
            }

            function renderSplineChart(chartName, data, settings) {
                var currentSettings = {
                    tooltip: settings.tooltip || { shared: true },
                    xAxis: settings.xAxis,
                    yAxis: settings.yAxis
                }

                Highcharts.setOptions({
                    lang: {
                        months: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
                        shortMonths: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                        weekdays: ["Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag", "Söndag"]
                    }
                });

                Highcharts.chart(chartName, {
                    chart: {
                        type: "areaspline"
                    },
                    title: {
                        text: ""
                    },
                    credits: {
                        enabled: false
                    },
                    legend: {
                        enabled: false,
                        layout: "vertical",
                        align: "left",
                        verticalAlign: "top",
                        x: 150,
                        y: 100,
                        floating: true,
                        borderWidth: 1,
                        backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || "#FFFFFF"
                    },
                    xAxis: currentSettings.xAxis,
                    yAxis: currentSettings.yAxis,
                    tooltip: currentSettings.tooltip,
                    plotOptions: {
                        areaspline: {
                            fillOpacity: 0.5,
                            marker: {
                                enabled: true
                            }
                        }
                    },
                    series: data
                });
            }

            function renderPieChart(chartName, data, settings) {
                var currentSettings = {
                    labelsFormat: settings.labelsFormat || "{y}"
                }

                Highcharts.chart(chartName, {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: "pie"
                    },
                    title: {
                        text: ""
                    },
                    credits: {
                        enabled: false
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: "pointer",
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },
                    tooltip: {
                        valueDecimals: 1,
                        valueSuffix: "%"
                    },
                    legend: {
                        //enabled: true,
                        //margin: 200,
                        //padding: 100,
                        itemDistance: 10,
                        itemWidth: 200,
                        width: 420,
                        x: 60
                    },
                    series: data
                });
            }

            function renderStackedChart(chartName, data, settings) {
                Highcharts.chart(chartName, {
                    chart: {
                        type: "area"
                    },
                    title: {
                        text: ""
                    },
                    credits: {
                        enabled: false
                    },
                    xAxis: settings.xAxis,
                    yAxis: settings.yAxis,
                    tooltip: {
                        split: false
                    },
                    plotOptions: {
                        series: {
                            marker: {
                                enabled: true
                            },
                            connectNulls: false
                        },
                        enableMouseTracking: false,
                        area: {
                            connectNulls: false,
                            stacking: "normal",
                            lineColor: "#666666",
                            lineWidth: 1,
                            marker: {
                                lineWidth: 1,
                                lineColor: "#666666"
                            }
                        }
                    },
                    series: data
                });
            }

            function getWeekChartCategories(weekLabels) {
                var categories, difference, i, j, len, previous, weekAndYear, weekCategory, weekIndex;
                categories = [];
                weekIndex = 0;
                difference = 0;
                i = 0;
                for (i = j = 0, len = weekLabels.length; j < len; i = ++j) {
                    weekAndYear = weekLabels[i];
                    if (weekLabels[i - 1] != null) {
                        previous = weekLabels[i - 1];
                        if (previous.year < weekAndYear.year) {
                            difference = (previous.week + weekAndYear.week) - previous.week;
                        } else {
                            difference = weekAndYear.week - previous.week;
                        }
                    }
                    weekIndex = weekIndex + difference;
                    weekCategory = {};
                    weekCategory.index = weekIndex;
                    weekCategory.week = weekAndYear.week;
                    weekCategory.year = weekAndYear.year;
                    weekCategory.label = weekAndYear.label;
                    categories.push(weekCategory);
                }
                return categories;
            };

            function thousandFormat(value) {
              return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            }

            return {
                renderDrillChart: renderDrillChart,
                renderColumnChart: renderColumnChart,
                renderSplineChart: renderSplineChart,
                renderPieChart: renderPieChart,
                renderStackedChart: renderStackedChart,
                renderBarChart: renderBarChart,
                getWeekChartCategories: getWeekChartCategories,
                thousandFormat: thousandFormat,
                renderStackedColumnChart: renderStackedColumnChart
            }
        });

}).call(this);


